/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import React from 'react';
import ITripState from '../../redux/model/ITripState';
import { testTrip } from '../testFunctions';
import styles from './TestComponent.module.scss';

interface ITestComponent {
  tripState: ITripState;
}

const TestComponent: React.FC<ITestComponent> = ({ tripState }) => (
  <div onClick={() => testTrip(tripState)} className={styles.container}>
    T
  </div>
);

export default TestComponent;
